import { render, staticRenderFns } from "./LabelDropdown.vue?vue&type=template&id=65d69bf0&scoped=true&"
import script from "./LabelDropdown.vue?vue&type=script&lang=js&"
export * from "./LabelDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LabelDropdown.vue?vue&type=style&index=0&id=65d69bf0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d69bf0",
  null
  
)

export default component.exports